import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Calendar from "../../component/common/calendar/Calendar";
import CalendarTable from "../../component/common/calendar/CalendarTable";

const mdTheme = createTheme();

const Attendance = () => {

  const [click_date, setClick_date] = useState(null);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "94vh",
            overflow: "auto",
          }}
        >
          <Container maxWidth="xl" sx={{ mt: 3, mb: 3 }}>
            <Grid container spacing={3}>
              {/* Chart */}
              <Grid item xs={4}>
                <Paper
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <Calendar setClick_date={setClick_date} />
                </Paper>
              </Grid>
              <Grid item xs={8}>
                <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
                {click_date != null ? (<CalendarTable click_date={click_date}/>):(<Box>데이터필요</Box>)}
                </Paper>
              </Grid>
              {/* Recent Deposits */}
              
            </Grid>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>

  );
}

export default Attendance;